import { WidgetState } from "@/apps/StudentExchangePartnerWidget/models/store-viewmodel"
import actions from "@/apps/StudentExchangePartnerWidget/store/actions"
import mutations from "@/apps/StudentExchangePartnerWidget/store/mutations"
import getters from "@/apps/StudentExchangePartnerWidget/store/getters"

export default {
    state: new WidgetState,
    actions: actions,
    mutations: mutations,
    getters: getters
}